import React from 'react';
import {
  UserOutlined,
  BlockOutlined,
  SettingOutlined,
  TeamOutlined,
  UsergroupAddOutlined,
  AppstoreOutlined,
  EnvironmentOutlined,
  ContainerOutlined,
  FileProtectOutlined,
  GoldOutlined,
  NodeExpandOutlined,
  FileTextOutlined,
  FileSyncOutlined,
  FileAddOutlined,
  FolderOpenOutlined,
  ExperimentOutlined,
  MedicineBoxOutlined,
  RadarChartOutlined,
  DeploymentUnitOutlined,
  DisconnectOutlined,
  SisternodeOutlined,
  ReconciliationOutlined,
  AuditOutlined,
  CreditCardOutlined,
  FundViewOutlined,
  BarChartOutlined,
  AreaChartOutlined,
  DotChartOutlined,
  LineChartOutlined,
  FundOutlined,
  ShopOutlined,
  BookOutlined,
  DollarCircleOutlined,
  DollarTwoTone,
  BankOutlined,
  RedEnvelopeOutlined,
} from '@ant-design/icons';

export interface SidebarNavigationItem {
  model?: string;
  policy?: string;
  title: string;
  key: string;
  url?: string;
  children?: SidebarNavigationItem[];
  icon?: React.ReactNode;
  cat_id?: React.ReactNode;
  lab_type?: React.ReactNode;
  rep_type?: React.ReactNode;
  customer_type?: React.ReactNode;
  import_type?: React.ReactNode;
}

export const sidebarNavigation: SidebarNavigationItem[] = [
  {
    policy: 'component',
    model: 'Menu',
    title: 'My Account',
    key: 'my-account',
    url: '/my-account',
    icon: <UserOutlined />,
  },
  {
    policy: 'setting',
    model: 'Menu',
    title: 'PR Configs',
    key: 'pr-config',
    icon: <SettingOutlined />,
    children: [
      {
        policy: 'viewAny',
        model: 'PrCategory',
        title: 'PR Categories',
        key: 'product-registrations-categories',
        url: '/product-registrations-categories',
        icon: <BlockOutlined />,
      },
      {
        policy: 'viewAny',
        model: 'PrProduct',
        title: 'PR Products',
        key: 'product-registration-products',
        url: '/product-registration-products',
        icon: <GoldOutlined />,
      },
      {
        policy: 'viewAny',
        model: 'PrProcess',
        title: 'PR Process',
        key: 'product-registration-processes',
        url: '/product-registration-processes',
        icon: <NodeExpandOutlined />,
      },
    ],
  },
  {
    policy: 'component',
    model: 'Menu',
    title: 'Product Registrations',
    key: 'product-registrations',
    url: 'pr-categories',
    icon: <ContainerOutlined />,
    // children: [
    // {
    //   policy: 'viewAny',
    //   model: 'ProductRegistration',
    //   title: 'Import Free Sales',
    //   key: 'product-registrations-imp-free-sales',
    //   url: '/product-registrations-imp-free-sales',
    //   icon: <ReconciliationOutlined />,
    //   cat_id: 2,
    // },
    // {
    //   policy: 'viewAny',
    //   model: 'ProductRegistration',
    //   title: 'Local Manufacture Free Sales',
    //   key: 'product-registrations-loc-man-free-sales',
    //   url: '/product-registrations-loc-man-free-sales',
    //   icon: <ReconciliationOutlined />,
    //   cat_id: 3,
    // },
    // {
    //   policy: 'viewAny',
    //   model: 'ProductRegistration',
    //   title: 'Manufacture License',
    //   key: 'product-registrations-manufacture-license',
    //   url: '/product-registrations-manufacture-license',
    //   icon: <ReconciliationOutlined />,
    //   cat_id: 4,
    // },
    // {
    //   policy: 'viewAny',
    //   model: 'ProductRegistration',
    //   title: 'Repacking',
    //   key: 'product-registrations-repacking',
    //   url: '/product-registrations-repacking',
    //   icon: <ReconciliationOutlined />,
    //   cat_id: 5,
    // },
    // {
    //   policy: 'viewAny',
    //   model: 'ProductRegistration',
    //   title: 'Export',
    //   key: 'product-registrations-vdb-export',
    //   url: '/product-registrations-vdb-export',
    //   icon: <ReconciliationOutlined />,
    //   cat_id: 6,
    // },
    // {
    //   policy: 'viewAny',
    //   model: 'ProductRegistration',
    //   title: 'User Permit',
    //   key: 'product-registrations-vdb-user-permit',
    //   url: '/product-registrations-vdb-user-permit',
    //   icon: <ReconciliationOutlined />,
    //   cat_id: 7,
    // },
    // {
    //   policy: 'viewAny',
    //   model: 'ProductRegistration',
    //   title: 'Feed Importer Registrations',
    //   key: 'product-registrations-feed-imp-registrations',
    //   url: '/product-registrations-feed-imp-registrations',
    //   icon: <FileProtectOutlined />,
    //   cat_id: 9,
    // },
    // {
    //   policy: 'viewAny',
    //   model: 'ProductRegistration',
    //   title: 'Feed Manufacturer Registration',
    //   key: 'product-registrations-feed-man-registration',
    //   url: '/product-registrations-feed-man-registration',
    //   icon: <FileProtectOutlined />,
    //   cat_id: 10,
    // },
    // {
    //   policy: 'viewAny',
    //   model: 'ProductRegistration',
    //   title: 'Poultry Breeder - Farm',
    //   key: 'product-registrations-poultry-breeder-farm',
    //   url: '/product-registrations-poultry-breeder-farm',
    //   icon: <FileProtectOutlined />,
    //   cat_id: 12,
    // },
    // {
    //   policy: 'viewAny',
    //   model: 'ProductRegistration',
    //   title: 'Poultry Breeder - Hatchery',
    //   key: 'product-registrations-poultry-breeder-hatch',
    //   url: '/product-registrations-poultry-breeder-hatch',
    //   icon: <FileProtectOutlined />,
    //   cat_id: 13,
    // },
    // {
    //   policy: 'viewAny',
    //   model: 'ProductRegistration',
    //   title: 'Export - Ornamental Fish',
    //   key: 'product-registrations-export-orn-fish',
    //   url: '/product-registrations-export-orn-fish',
    //   icon: <FileProtectOutlined />,
    //   cat_id: 15,
    // },
    // {
    //   policy: 'viewAny',
    //   model: 'ProductRegistration',
    //   title: 'Export - Commercial Eggs',
    //   key: 'product-registrations-commercial-eggs',
    //   url: '/product-registrations-commercial-eggs',
    //   icon: <FileProtectOutlined />,
    //   cat_id: 16,
    // },
    // {
    //   policy: 'viewAny',
    //   model: 'ProductRegistration',
    //   title: 'Export - Pet Birds',
    //   key: 'product-registrations-pet-birds',
    //   url: '/product-registrations-pet-birds',
    //   icon: <FileProtectOutlined />,
    //   cat_id: 17,
    // },
    // {
    //   policy: 'viewAny',
    //   model: 'ProductRegistration',
    //   title: 'Export - Animal Products Establishments',
    //   key: 'product-registrations-animal-products-establishments',
    //   url: '/product-registrations-animal-products-establishments',
    //   icon: <FileProtectOutlined />,
    //   cat_id: 18,
    // },
    // ],
  },
  {
    policy: 'component',
    model: 'Menu',
    title: 'My Registration Data',
    key: 'pr-feed-forms-anexures',
    icon: <BookOutlined />,
    children: [
      {
        policy: 'viewAny',
        model: 'PrFeedProduction',
        title: 'Farm Data',
        key: 'all-farms',
        url: '/all-farms',
        icon: <ShopOutlined />,
      },
      {
        policy: 'viewAny',
        model: 'PrFeedProduction',
        title: 'Feed Productions',
        key: 'feed-productions',
        url: '/feed-productions',
        icon: <FileTextOutlined />,
      },
      {
        policy: 'viewAny',
        model: 'PrFeedForecast',
        title: 'Feed Forecast',
        key: 'feed-forecasts',
        url: '/feed-forecasts',
        icon: <FileTextOutlined />,
      },
      {
        policy: 'viewAny',
        model: 'PrFeedExpectedIngredient',
        title: 'Feed Expected Ingredients',
        key: 'feed-exp-ingredients',
        url: '/feed-exp-ingredients',
        icon: <FileTextOutlined />,
      },
      {
        policy: 'viewAny',
        model: 'PrFeedIngredientUsage',
        title: 'Feed Material Usage',
        key: 'feed-material-usage',
        url: '/feed-material-usage',
        icon: <FileTextOutlined />,
      },
      {
        policy: 'viewAny',
        model: 'PrFeedProduction',
        title: 'Feed Importation',
        key: 'feed-imports',
        url: '/feed-imports',
        icon: <FileTextOutlined />,
      },
    ],
  },
  {
    policy: 'component',
    model: 'Menu',
    title: 'Pre-Clearance',
    key: 'pre-clearance',
    icon: <UserOutlined />,
    children: [
      {
        policy: 'viewAny',
        model: 'PreClearance',
        title: 'Pre-Clearance ',
        key: 'pre-clearance',
        url: '/pre-clearance',
        icon: <AppstoreOutlined />,
      },
      {
        policy: 'viewAny',
        model: 'PreClearanceCategory',
        title: 'Pre-Clearance Categories',
        key: 'pre-clearance-categories',
        url: '/pre-clearance-categories',
        icon: <AppstoreOutlined />,
      },
    ],
  },
  {
    policy: 'vri',
    model: 'Menu',
    title: 'Labs & Research',
    key: 'labs-research',
    icon: <ExperimentOutlined />,
    children: [
      {
        policy: 'viewAny',
        model: 'LabRequest',
        title: 'Regular Tests',
        key: 'lab-regular-tests',
        url: '/lab-regular-tests',
        icon: <DisconnectOutlined />,
        lab_type: 'REGULAR_TEST',
      },
      {
        policy: 'viewAny',
        model: 'LabRequest',
        title: 'AQO Initiated',
        key: 'lab-aqo-initiated',
        url: '/lab-aqo-initiated',
        icon: <DeploymentUnitOutlined />,
        lab_type: 'AQO_INITIATED',
      },
      {
        policy: 'viewAny',
        model: 'LabRequest',
        title: 'Bi-Annual Tests',
        key: 'lab-bi-annual-tests',
        url: '/lab-bi-annual-tests',
        icon: <SisternodeOutlined />,
        lab_type: 'BI_ANNUAL',
      },
      {
        policy: 'viewAny',
        model: 'LabRequest',
        title: 'Direct Sales',
        key: 'lab-direct-sales',
        url: '/lab-direct-sales',
        icon: <ReconciliationOutlined />,
        lab_type: 'DIRECT_SALES',
      },
      {
        policy: 'viewAny',
        model: 'LabRequest',
        title: 'Vaccine Manufacture',
        key: 'lab-vaccine-manufacture',
        url: '/lab-vaccine-manufacture',
        icon: <MedicineBoxOutlined />,
        lab_type: 'VACCINE_MANUFACTURING',
      },
      {
        policy: 'viewAny',
        model: 'LabRequest',
        title: 'Disease Surveillance',
        key: 'lab-disease-surveillance',
        url: '/lab-disease-surveillance',
        icon: <RadarChartOutlined />,
        lab_type: 'DISEASE_SURVEILLANCE',
      },
    ],
  },

  {
    policy: 'component',
    model: 'Menu',
    title: 'Data Library',
    key: 'data-library',
    icon: <AppstoreOutlined />,
    children: [
      {
        policy: 'viewAny',
        model: 'ProductCategory',
        title: 'Product Categories',
        key: 'product_categories',
        url: '/product-categories',
        icon: <AppstoreOutlined />,
      },
      {
        policy: 'viewAny',
        model: 'Product',
        title: 'Products',
        key: 'products',
        url: '/products',
        icon: <AppstoreOutlined />,
      },
      {
        policy: 'viewAny',
        model: 'ProductVariety',
        title: 'Product Varieties',
        key: 'product-varieties',
        url: '/product-varieties',
        icon: <AppstoreOutlined />,
      },
      {
        policy: 'viewAny',
        model: 'Location',
        title: 'Locations',
        key: 'locations',
        url: '/locations',
        icon: <EnvironmentOutlined />,
      },
      {
        policy: 'viewAny',
        model: 'Department',
        title: 'Departments',
        key: 'departments',
        url: '/departments',
        icon: <EnvironmentOutlined />,
      },
    ],
  },
  {
    policy: 'component',
    model: 'Menu',
    title: 'Import',
    key: 'import',
    icon: <FileProtectOutlined />,
    children: [
      {
        policy: 'viewAny',
        model: 'Import',
        title: 'Normal',
        key: 'import-normal',
        url: '/import/normal',
        icon: <FileProtectOutlined />,
        import_type: 'NORMAL',
      },
      {
        policy: 'viewAny',
        model: 'Import',
        title: 'Non-Compliance 1',
        key: 'import-non-compliance-1',
        url: '/import/non-compliance-1',
        icon: <FileProtectOutlined />,
        import_type: 'NON_COMPLIANCE_1',
      },
      {
        policy: 'viewAny',
        model: 'Import',
        title: 'Non-Compliance 3',
        key: 'import-non-compliance-3',
        url: '/import/non-compliance-3',
        icon: <FileProtectOutlined />,
        import_type: 'NON_COMPLIANCE_3',
      },
      {
        policy: 'viewAny',
        model: 'Import',
        title: 'No Objection',
        key: 'import-no-objection',
        url: '/import/no-objection',
        icon: <FileProtectOutlined />,
        import_type: 'NO_OBJECTION',
      },
      {
        policy: 'viewAny',
        model: 'Import',
        title: 'Non-Relevant',
        key: 'import-non-relevant',
        url: '/import/non-relevant',
        icon: <FileProtectOutlined />,
        import_type: 'NON_RELEVANT',
      },
      {
        policy: 'viewAny',
        model: 'Import',
        title: 'Follow-Ups',
        key: 'follow-ups',
        url: '/follow-ups',
        icon: <FileProtectOutlined />,
      },
    ],
  },
  {
    policy: 'component',
    model: 'Menu',
    title: 'Export',
    key: 'export',
    icon: <FundViewOutlined />,
    children: [
      {
        policy: 'viewAny',
        model: 'Export',
        title: 'Normal',
        key: 'export-normal',
        url: 'export/normal',
        icon: <GoldOutlined />,
      },
      {
        policy: 'viewAny',
        model: 'Export',
        title: 'Feed and Drugs',
        key: 'export-feed-and-drugs',
        url: '/export/feed-and-drugs',
        icon: <NodeExpandOutlined />,
      },
      {
        policy: 'viewAny',
        model: 'Export',
        title: 'Export Extensions',
        key: 'export-extensions',
        url: '/export-extensions',
        icon: <NodeExpandOutlined />,
      },
    ],
  },
  {
    policy: 'component',
    model: 'FollowUp',
    title: 'Follow Up',
    key: 'follow-up',
    url: '/follow-ups',
    icon: <AuditOutlined />,
  },
  {
    policy: 'component',
    model: 'Menu',
    title: 'Nominal Payments',
    key: 'nominal-payments',
    url: '/nominal-payments',
    icon: <CreditCardOutlined />,
  },
  {
    policy: 'billing',
    model: 'Menu',
    title: 'Finance',
    key: 'finance',
    icon: <BankOutlined />,
    children: [
      {
        policy: 'viewAny',
        model: 'Invoice',
        title: 'Invoices',
        key: 'all-invoices',
        url: 'all-invoices',
        icon: <DollarCircleOutlined />,
      },
      {
        policy: 'viewAny',
        model: 'Receipt',
        title: 'Receipts',
        key: 'all-receipts',
        url: 'all-receipts',
        icon: <RedEnvelopeOutlined />,
      },
    ],
  },
  {
    policy: 'viewAny',
    model: 'Customer',
    title: 'Customers',
    key: 'customers',
    icon: <UserOutlined />,
    children: [
      {
        policy: 'viewAny',
        model: 'Customer',
        title: 'New Customers',
        key: 'new-customers',
        url: '/new-customers',
        icon: <UserOutlined />,
        customer_type: 'NEW',
      },
      {
        policy: 'viewAny',
        model: 'Customer',
        title: 'Verified Customers',
        key: 'verified-customers',
        url: '/verified-customers',
        icon: <UserOutlined />,
        customer_type: 'VERIFIED',
      },
    ],
  },
  {
    policy: 'vri',
    model: 'Menu',
    title: 'Reports',
    key: 'reports',
    icon: <BarChartOutlined />,
    children: [
      {
        policy: 'viewAny',
        model: 'LabRequest',
        title: 'Lab Reports',
        key: 'Lab Reports',
        url: '/lab-reports',
        rep_type: 'lab',
        icon: <DotChartOutlined />,
      },
      {
        policy: 'viewAny',
        model: 'User',
        title: 'PR & License Reports',
        key: 'PR & License Reports',
        url: '/pr-license-reports',
        rep_type: 'pr&license',
        icon: <FileTextOutlined />,
      },
      {
        policy: 'viewAny',
        model: 'User',
        title: 'Import & Export Reports',
        key: 'Import & Export Reports',
        url: '/import-export-reports',
        rep_type: 'import&export',
        icon: <LineChartOutlined />,
      },
      // {
      //   policy: 'viewAny',
      //   model: 'User',
      //   title: 'Follow Up Reports',
      //   key: 'Follow Up Reports',
      //   url: '/followup-reports',
      //   rep_type: 'followup',
      //   icon: <FundOutlined />,
      // },
      {
        policy: 'viewAny',
        model: 'User',
        title: 'Financial Reports',
        key: 'Financial Reports',
        url: '/finance-reports',
        rep_type: 'finance',
        icon: <AreaChartOutlined />,
      },
    ],
  },
  {
    policy: 'setting',
    model: 'Menu',
    title: 'Settings',
    key: 'settings',
    icon: <UsergroupAddOutlined />,
    children: [
      {
        policy: 'viewAny',
        model: 'User',
        title: 'All Users',
        key: 'All Users',
        url: '/users',
        icon: <TeamOutlined />,
      },
      {
        policy: 'viewAny',
        model: 'users',
        title: 'User Roles',
        key: 'User Roles',
        url: '/user-roles',
        icon: <SettingOutlined />,
      },
    ],
  },
  {
    policy: 'setting',
    model: 'Menu',
    title: 'Post',
    key: 'post',
    icon: <FileTextOutlined />,
    children: [
      {
        policy: 'viewAny',
        model: 'Post',
        title: 'Posts',
        key: 'posts',
        url: '/posts',
        icon: <FileAddOutlined />,
      },
      {
        policy: 'viewAny',
        model: 'PostCategory',
        title: 'Post Categories',
        key: 'post-categories',
        url: '/post-categories',
        icon: <FolderOpenOutlined />,
      },
    ],
  },
  // {
  //   policy: 'setting',
  //   model: 'Menu',
  //   title: 'Activity Log',
  //   key: 'activity_log',
  //   url: '/activity_log',
  //   icon: <CreditCardOutlined />,
  // },

  // {
  //   title: 'common.nft-dashboard',
  //   key: 'nft-dashboard',
  //   // TODO use path variable
  //   url: '/net-dashboard',
  //   icon: <NftIcon />,
  // },
  // {
  //   title: 'common.medical-dashboard',
  //   key: 'medical-dashboard',
  //   url: '/medical-dashboard',
  //   icon: <DashboardOutlined />,
  // },
  // {
  //   title: 'common.apps',
  //   key: 'apps',
  //   icon: <HomeOutlined />,
  //   children: [
  //     {
  //       title: 'common.feed',
  //       key: 'feed',
  //       url: '/apps/feed',
  //     },
  //   ],
  // },
  // {
  //   title: 'common.authPages',
  //   key: 'auth',
  //   icon: <UserOutlined />,
  //   children: [
  //     {
  //       title: 'common.clogin',
  //       key: 'customer_login',
  //       url: '/customer_login',
  //     },
  //     {
  //       title: 'common.login',
  //       key: 'login',
  //       url: '/auth/login',
  //     },
  //     {
  //       title: 'common.signUp',
  //       key: 'singUp',
  //       url: '/auth/sign-up',
  //     },
  //     {
  //       title: 'common.lock',
  //       key: 'lock',
  //       url: '/auth/lock',
  //     },
  //     {
  //       title: 'common.forgotPass',
  //       key: 'forgotPass',
  //       url: '/auth/forgot-password',
  //     },
  //     {
  //       title: 'common.securityCode',
  //       key: 'securityCode',
  //       url: '/auth/security-code',
  //     },
  //     {
  //       title: 'common.newPassword',
  //       key: 'newPass',
  //       url: '/auth/new-password',
  //     },
  //   ],
  // },
  // {
  //   title: 'common.forms',
  //   key: 'forms',
  //   icon: <FormOutlined />,
  //   children: [
  //     {
  //       title: 'common.advancedForms',
  //       key: 'advanced-forms',
  //       url: '/forms/advanced-forms',
  //     },
  //   ],
  // },
  // {
  //   title: 'common.dataTables',
  //   key: 'dataTables',
  //   url: '/data-tables',
  //   icon: <TableOutlined />,
  // },
  // {
  //   title: 'common.charts',
  //   key: 'charts',
  //   url: '/charts',
  //   icon: <LineChartOutlined />,
  // },
  // {
  //   title: 'common.maps',
  //   key: 'maps',
  //   icon: <CompassOutlined />,
  //   children: [
  //     {
  //       title: 'common.googleMap',
  //       key: 'google-maps',
  //       url: '/maps/google-maps',
  //     },
  //     {
  //       title: 'common.leafletMap',
  //       key: 'leaflet-maps',
  //       url: '/maps/leaflet-maps',
  //     },
  //     {
  //       title: 'common.reactSimpleMaps',
  //       key: 'react-simple-maps',
  //       url: '/maps/react-simple-maps',
  //     },
  //     {
  //       title: 'common.pigeonMaps',
  //       key: 'pigeon-maps',
  //       url: '/maps/pigeon-maps',
  //     },
  //   ],
  // },
  // {
  //   title: 'common.pages',
  //   key: 'pages',
  //   icon: <LayoutOutlined />,
  //   children: [
  //     {
  //       title: 'common.profilePage',
  //       key: 'profile',
  //       url: '/profile',
  //     },
  //     {
  //       title: 'common.serverError',
  //       key: 'serverError',
  //       url: '/server-error',
  //     },
  //     {
  //       title: 'common.clientError',
  //       key: '404Error',
  //       url: '/404',
  //     },
  //   ],
  // },
  // {
  //   title: 'common.ui',
  //   key: 'ui',
  //   icon: <BlockOutlined />,
  //   children: [
  //     {
  //       title: 'common.alert',
  //       key: 'alert',
  //       url: '/ui-components/alert',
  //     },
  //     {
  //       title: 'common.avatar',
  //       key: 'avatar',
  //       url: '/ui-components/avatar',
  //     },
  //     {
  //       title: 'common.autocomplete',
  //       key: 'auto-complete',
  //       url: '/ui-components/auto-complete',
  //     },
  //     {
  //       title: 'common.badge',
  //       key: 'badge',
  //       url: '/ui-components/badge',
  //     },
  //     {
  //       title: 'common.breadcrumbs',
  //       key: 'breadcrumbs',
  //       url: '/ui-components/breadcrumbs',
  //     },
  //     {
  //       title: 'common.button',
  //       key: 'button',
  //       url: '/ui-components/button',
  //     },
  //     {
  //       title: 'common.checkbox',
  //       key: 'checkbox',
  //       url: '/ui-components/checkbox',
  //     },
  //     {
  //       title: 'common.collapse',
  //       key: 'collapse',
  //       url: '/ui-components/collapse',
  //     },
  //     {
  //       title: 'common.dateTimePicker',
  //       key: 'dateTimePicker',
  //       url: '/ui-components/date-time-picker',
  //     },
  //     {
  //       title: 'common.dropdown',
  //       key: 'dropdown',
  //       url: '/ui-components/dropdown',
  //     },
  //     {
  //       title: 'common.input',
  //       key: 'input',
  //       url: '/ui-components/input',
  //     },
  //     {
  //       title: 'common.modal',
  //       key: 'modal',
  //       url: '/ui-components/modal',
  //     },
  //     {
  //       title: 'common.notification',
  //       key: 'notification',
  //       url: '/ui-components/notification',
  //     },
  //     {
  //       title: 'common.pagination',
  //       key: 'pagination',
  //       url: '/ui-components/pagination',
  //     },
  //     {
  //       title: 'common.popconfirm',
  //       key: 'popconfirm',
  //       url: '/ui-components/popconfirm',
  //     },
  //     {
  //       title: 'common.popover',
  //       key: 'popover',
  //       url: '/ui-components/popover',
  //     },
  //     {
  //       title: 'common.progress',
  //       key: 'progress',
  //       url: '/ui-components/progress',
  //     },
  //     {
  //       title: 'common.radio',
  //       key: 'radio',
  //       url: '/ui-components/radio',
  //     },
  //     {
  //       title: 'common.rate',
  //       key: 'rate',
  //       url: '/ui-components/rate',
  //     },
  //     {
  //       title: 'common.result',
  //       key: 'result',
  //       url: '/ui-components/result',
  //     },
  //     {
  //       title: 'common.select',
  //       key: 'select',
  //       url: '/ui-components/select',
  //     },
  //     {
  //       title: 'common.skeleton',
  //       key: 'skeleton',
  //       url: '/ui-components/skeleton',
  //     },
  //     {
  //       title: 'common.spinner',
  //       key: 'spinner',
  //       url: '/ui-components/spinner',
  //     },
  //     {
  //       title: 'common.steps',
  //       key: 'steps',
  //       url: '/ui-components/steps',
  //     },
  //     {
  //       title: 'common.switch',
  //       key: 'switch',
  //       url: '/ui-components/switch',
  //     },
  //     {
  //       title: 'common.tabs',
  //       key: 'tabs',
  //       url: '/ui-components/tabs',
  //     },
  //     {
  //       title: 'common.upload',
  //       key: 'upload',
  //       url: '/ui-components/upload',
  //     },
  //   ],
  // },
];
